import styled from 'styled-components';

export const SessionLockOverlay = styled.div<{ $active: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 2147483646;
  cursor: not-allowed;
  pointer-events: ${(props) => (props.$active ? 'auto' : 'none')};
`;
